import { SharingData } from '../../schema/SharingData';
import { SharingInfo } from '../../schema/SharingInfo';
import { isUnshareable } from '../../selectors/sharingIssueDetectors/isUnshareable';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { isFeatureEnabled } from 'owa-feature-flags';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import { GetPermissionInfoStatus } from 'owa-sharing-data';

export function isPermissionNotSet(
    sharingData: SharingData,
    recipientInfo: SharingTipRecipientInfo[]
): boolean {
    if (shouldUseGenericError(sharingData.sharingInfo)) {
        return (
            sharingData.currentPermissionLevel === AttachmentPermissionLevel.None &&
            !isUnshareable(sharingData)
        );
    } else {
        return hasRecipientThatCanNotAccess(sharingData);
    }
}

export function shouldUseGenericError(sharingInfo: SharingInfo): boolean {
    return (
        !isFeatureEnabled('doc-recipient-permission') ||
        sharingInfo.hasDLRecipient ||
        hasGetRecipientPermissionFailed(sharingInfo)
    );
}

function hasGetRecipientPermissionFailed(sharingInfo: SharingInfo): boolean {
    return sharingInfo.recipientPermissionInfos.some(
        info => info.getPermissionInfoStatus === GetPermissionInfoStatus.Failed
    );
}

function hasRecipientThatCanNotAccess(sharingData: SharingData): boolean {
    return sharingData.sharingInfo.recipientPermissionInfos.some(
        info =>
            !info.hasAccess && info.getPermissionInfoStatus === GetPermissionInfoStatus.Succeeded
    );
}
